import React, { useState, useEffect } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import "../assets/admin.css"
import { dataset, valueFormatter, rankingDownload } from '../datasets/search';
import { PieChart } from '@mui/x-charts/PieChart';
import axios from 'axios';

const AdminDashboard = () => {

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`https://geoid-rest.vercel.app/users/`);
        setUsers(response.data);
        console.log('Users fetched:', response.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const user = JSON.parse(localStorage.getItem('user'));

  const searchKeywordsDataset = [
    { keyword: 'Stoneware', searches: 12 },
    { keyword: 'Pottery', searches: 15 },
    { keyword: 'Shipwreck', searches: 8 },
    { keyword: 'Ceramics', searches: 5 },
    { keyword: 'History', searches: 10 },
    { keyword: 'Archaeology', searches: 7 },
    { keyword: 'Artifact', searches: 6 },
    { keyword: 'Excavation', searches: 4 },
    { keyword: 'Museum', searches: 9 },
    { keyword: 'Exhibit', searches: 11 },
    { keyword: 'Research', searches: 10 },
    { keyword: 'Preservation', searches: 8 },
    { keyword: 'Culture', searches: 12 },
    // { keyword: 'Heritage', searches: 14 },
    // { keyword: 'Exhibition', searches: 16 },
    // { keyword: 'Fossil', searches: 13 },
    // { keyword: 'Artifact', searches: 18 },
    // { keyword: 'Paleontology', searches: 15 },
    // { keyword: 'Conservation', searches: 20 },
    // { keyword: 'Restoration', searches: 11 },
    // { keyword: 'Ancient', searches: 9 },
    // { keyword: 'Geology', searches: 6 },
    // { keyword: 'Mineralogy', searches: 7 },
    // { keyword: 'Archaeologist', searches: 10 },
    // { keyword: 'Expedition', searches: 5 },
    // { keyword: 'Fieldwork', searches: 12 },
    // { keyword: 'Dig', searches: 14 },
    // { keyword: 'Anthropology', searches: 8 },
  ];
  const totalSearches = searchKeywordsDataset.reduce((acc, item) => acc + item.searches, 0);

  const pieChartData = searchKeywordsDataset.map((item, index) => ({
      id: index,
      label: item.keyword,
      value: item.searches, // percentage
  }));

  const chartSetting = {
    yAxis: [
      {
        label: 'number',
      },
    ],
    width: 650,
    height: 350,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-20px, 0)',
      },
    },
  };

  const chartSetting2 = {
    xAxis: [
      {
        label: 'Downloads',
      },
    ],
    layout: 'horizontal',
    width: 750,
    height: 350,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-20px, 0)',
      },
    },
  };

  return (
    <div className='admin-dashboard'>
      <div className='userTable'>
        <label>REGISTERED USER</label>
        <table className="user-table">
          <thead>
              <tr>
                  <th>Username</th>
                  <th>Displayed Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Industry</th>
              </tr>
          </thead>
          <tbody>
              {users.length > 0 ? (  // Check if participants exist
                  users.map((users, index) => (
                      <tr key={index}>
                          <td>{users.username || '-'}</td>
                          <td>{users.display_name || '-'}</td>
                          <td>{users.email || '-'}</td>
                          <td>{users.company || '-'}</td>
                          <td>{users.industry || '-'}</td>
                      </tr>
                  ))
              ) : (
                  <tr>
                      <td colSpan="9" style={{ textAlign: 'center' }}>No users yet.</td>
                  </tr>
              )}
          </tbody>
      </table>
      </div>
      {user.user.type != 'owner' &&(
        <>
          <div className='numStats'>
          <div className='searchAdmin'>
            <div className='data'>
              <div style={{textAlign: 'left'}}>
                <p>VISITS</p>
                <h1>597</h1>
              </div>
              <span className='icon-visit'>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
                </svg>
              </span>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{color: "#15b79f"}}>↑ 12% </p>
              <p>&nbsp; since last month</p>
            </div>
          </div>
          <div className='searchAdmin'>
            <div className='data'>
              <div style={{textAlign: 'left'}}>
                <p>SEARCH</p>
                <h1>450</h1>
              </div>
              <span className='icon-search'>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-search" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                </svg>
              </span>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{color: "#f04438"}}>↓ 5% </p>
              <p>&nbsp; since last month</p>
            </div>
          </div>
          <div className='searchAdmin'>
            <div className='data'>
              <div style={{textAlign: 'left'}}>
                <p>UPLOADS</p>
                <h1>37</h1>
              </div>
              <span className='icon-upload'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-cloud-upload-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0m-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0"/>
                  </svg>
              </span>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{color: "#15b79f"}}>↑ 24% </p>
              <p>&nbsp; since last month</p>
            </div>
          </div>
          <div className='searchAdmin'>
            <div className='data'>
              <div style={{textAlign: 'left'}}>
                <p>DOWNLOADS</p>
                <h1>132</h1>
              </div>
              <span className='icon-visit'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-download" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                  </svg>
              </span>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{color: "#15b79f"}}>↑ 14% </p>
              <p>&nbsp; since last month</p>
            </div>
          </div>
        </div>

        <div className='graphStats' style={{marginTop: "40px"}}>
          <div className='lineGraph'>
            <span style={{textAlign: 'left', display: 'flex'}}>STATISTICS</span>
            <div style={{display: 'flex'}}>
              <BarChart
                dataset={dataset}
                xAxis={[{ scaleType: 'band', dataKey: 'date' }]}
                series={[
                  { dataKey: 'visits', label: 'Visits', valueFormatter, color: '#635bff' },
                  { dataKey: 'uploads', label: 'Uploads', valueFormatter, color: '#15b79f' },
                  { dataKey: 'downloads', label: 'Downloads', valueFormatter, color: "#fb9c0c" },
                ]}
                {...chartSetting}
              />
            </div>
          </div>
          <div className='radialGraph'>
            <span style={{textAlign: 'left', display: 'flex', borderBottom: '1px solid #e5e5e5'}} className='tablePadding'>
              SEARCHED KEYWORDS RANKING
            </span>
            <div className='text-gray contentPadding' 
            style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', backgroundColor: 'rgb(247 247 247)'}}>
              <p>Keywords</p>
              <p>Frequency (Percentage)</p>
            </div>
            <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
              <p>1. Fossils</p>
              <p className='pill-green'>46 (13.41%)</p>
            </div>
            <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
              <p>2. Limestone </p>
              <p className='pill-green'>44 (12.83%)</p>
            </div>
            <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
              <p>3. Quartzite </p>
              <p className='pill-green'>40 (11.66%)</p>
            </div>
            <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
              <p>4. Igneous rocks</p>
              <p className='pill-green'>31 (9.04%)</p>
            </div>
            <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between'}}>
              <p>5. Plate tectonics</p>
              <p className='pill-green'>30 (8.75%)</p>
            </div>
              {/* <PieChart
                series={[
                    {
                        innerRadius: 60,
                        data: pieChartData,
                    },
                ]}
                width={400}
                height={300}
                slotProps={{
                  legend: {
                    direction: 'row',
                    position: { vertical: 'bottom', horizontal: 'middle' },
                    padding: 0,
                    labelStyle:{
                      fontSize: 14
                    },
                    itemMarkWidth: 11,
                    itemMarkHeight: 10,
                  },
                }}
                margin={{ bottom: 100, left: 100, right: 100 }}
            /> */}
          </div>
        </div>
        </>
      )}

      {user.user.type == 'owner' &&(
        <>
          <div className='numStats'>
            <div className='revenueData'>
              <div className='data'>
                <div style={{textAlign: 'left'}}>
                  <p>REVENUE</p>
                  <h1>RM 1230</h1>
                </div>
                <span className='icon-revenue'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" class="bi bi-coin" viewBox="0 0 16 16">
                    <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"/>
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/>
                  </svg>
                </span>
              </div>
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <p style={{color: "#15b79f"}}>↑ 12% </p>
                <p>&nbsp; since last month</p>
              </div>
              <div className='data'>
                <div style={{textAlign: 'left'}}>
                    <p>TOTAL PURCHASES</p>
                    <h1>124</h1>
                </div>
                <span className='icon-revenue'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" class="bi bi-cart4" viewBox="0 0 16 16">
                    <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l.5 2H5V5zM6 5v2h2V5zm3 0v2h2V5zm3 0v2h1.36l.5-2zm1.11 3H12v2h.61zM11 8H9v2h2zM8 8H6v2h2zM5 8H3.89l.5 2H5zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/>
                  </svg>
                </span>
              </div>
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <p style={{color: "#15b79f"}}>↑ 50% </p>
                <p>&nbsp; since last month</p>
              </div>
            </div>

            <div className='recentPurchase'>
              <span style={{textAlign: 'left', display: 'flex', borderBottom: '1px solid #e5e5e5'}} className='tablePadding'>
                RECENT PURCHASES
              </span>
              <div className='text-gray contentPadding' 
              style={{display: 'flex', gap: '100px', textAlign: 'left', borderBottom: '1px solid #e5e5e5', backgroundColor: 'rgb(247 247 247)'}}>
                <p style={{width: '20%'}}>Username</p>
                <p style={{width: '70%'}}>Item Purchased</p>
                <p style={{width: '10%'}}>Price</p>
              </div>
              <div className='contentPadding' style={{display: 'flex', gap: '100px', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
                <p className='purchasee'>user33</p>
                <p className='purchasedItem'>limestone with foraminifera (3D Model)</p>
                <p className='pill-revenue'>RM 100</p>
              </div>
              <div className='contentPadding' style={{display: 'flex', gap: '100px', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
                <p className='purchasee'>aqusyairin </p>
                <p className='purchasedItem'>Multiple Deformations at ... (Reports)</p>
                <p className='pill-revenue'>RM 5</p>
              </div>
              <div className='contentPadding' style={{display: 'flex', gap: '100px', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
                <p className='purchasee'>aqusyairin </p>
                <p className='purchasedItem'>P-T-XH2O Conditions of S... (Reports)</p>
                <p className='pill-revenue'>RM 5</p>
              </div>
              <div className='contentPadding' style={{display: 'flex', gap: '100px', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
                <p className='purchasee'>afif.test</p>
                <p className='purchasedItem'>Multiple Deformations at ... (Reports)</p>
                <p className='pill-revenue'>RM 5</p>
              </div>
              <div className='contentPadding' style={{display: 'flex', gap: '100px', justifyContent: 'space-between'}}>
                <p className='purchasee'>aqusyairin</p>
                <p className='purchasedItem'>Late Si Satchanalai Under... (3D Model)</p>
                <p className='pill-revenue'>RM 100</p>
              </div>

            </div>
          </div>
        </>
      )}

      <div className='graphStats' style={{marginTop: "40px"}}>
        <div className='uploadData'>
          <span style={{textAlign: 'left', display: 'flex'}}>UPLOAD</span>
            <PieChart
              series={[
                {
                  data: [
                    { id: 0, value: 20, label: `Report` },
                    { id: 1, value: 3, label: 'Model', color: 'orange' },
                    { id: 2, value: 14, label: 'Multimedia', color: 'lightcoral' },
                  ],
                },
              ]}
              width={400}
              height={200}
            />
        </div>
        <div className='downloadData'>
          <span style={{textAlign: 'left', display: 'flex'}}>DOWNLOAD</span>
          <PieChart
              series={[
                {
                  data: [
                    { id: 0, value: 12, label: 'Report' },
                    { id: 1, value: 20, label: 'Model', color: 'orange' },
                    { id: 2, value: 10, label: 'Multimedia', color: 'lightcoral' },
                  ],
                },
              ]}
              width={400}
              height={200}
            />
        </div>
      </div>

      <div className='graphStats' style={{marginTop: "40px"}}>
        <div className='userRanking'>
        <span style={{textAlign: 'left', display: 'flex', borderBottom: '1px solid #e5e5e5'}} className='tablePadding'>
            USER DOWNLOAD RANKING
          </span>
          <div className='text-gray contentPadding' 
          style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', backgroundColor: 'rgb(247 247 247)'}}>
            <p>Username</p>
            <p>Downloads (Percentage)</p>
          </div>
          <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
            <p>1. amzaraznan</p>
            <p className='pill-purple'>18 (42.86%)</p>
          </div>
          <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
            <p>2. cheemeng1987 </p>
            <p className='pill-purple'>10 (23.81%)</p>
          </div>
          <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
            <p>3. dgeguser </p>
            <p className='pill-purple'>8 (19.05%)</p>
          </div>
          <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5'}}>
            <p>4. afif.test</p>
            <p className='pill-purple'>4 (9.52%)</p>
          </div>
          <div className='contentPadding' style={{display: 'flex', justifyContent: 'space-between'}}>
            <p>5. aqusyairin</p>
            <p className='pill-purple'>2 (4.76%)</p>
          </div>

        </div>
        <div className='downloadRanking'>
          <span style={{textAlign: 'left', display: 'flex'}}>
            DOWNLOADED ITEMS RANKING
          </span>
          <BarChart
              dataset={rankingDownload}
              yAxis={[{ scaleType: 'band', dataKey: 'name' }]}
              with
              series={[
                { dataKey: 'downloads', label: 'Downloads', color: '#635bff' },
              ]}
              grid={{ vertical: true }}
              leftAxis={null}
              {...chartSetting2}
            />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;